import React from 'react';

const QuotationMarkIcon = ({ ...props }) => (
  <svg
    width="28"
    height="24"
    viewBox="0 0 28 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28 0V4.24561C25.8492 4.64327 24.1818 5.60234 22.9979 7.12281C21.814 8.64328 21.222 10.5848 21.222 12.9474V13.5789H24.8626C25.3756 14.1637 25.7505 14.8421 25.9873 15.614C26.2438 16.3626 26.3721 17.2164 26.3721 18.1754C26.3721 19.9766 25.9281 21.4035 25.0402 22.4561C24.1522 23.4854 22.9387 24 21.3996 24C19.5053 24 17.9958 23.2515 16.871 21.7544C15.766 20.2573 15.2135 18.2339 15.2135 15.6842C15.2135 11.5673 16.3975 8.04678 18.7653 5.12281C21.1529 2.19883 24.2311 0.491228 28 0ZM12.7865 0V4.24561C10.6357 4.66667 8.97815 5.64912 7.81395 7.19298C6.64975 8.71345 6.06765 10.6784 6.06765 13.0877V13.5789H9.64905C10.1621 14.1637 10.537 14.8421 10.7738 15.614C11.0303 16.3626 11.1586 17.2164 11.1586 18.1754C11.1586 19.9766 10.7146 21.4035 9.82664 22.4561C8.93869 23.4854 7.72516 24 6.18605 24C4.29175 24 2.78224 23.2515 1.65751 21.7544C0.552502 20.2573 0 18.2339 0 15.6842C0 11.5673 1.18393 8.04678 3.5518 5.12281C5.93939 2.19883 9.01762 0.491228 12.7865 0Z"
      fill="#F5631A"
    />
  </svg>
);

export default QuotationMarkIcon;
